<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="4">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加GPT描述"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
            ref="addGpt"  
            @on-ok="addSumit" 
            @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="编辑GPT描述"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        ref="editGpt"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_gpt_form.vue";
import { getGptList, addGpt, getClassifys, editGpt, deleteGpt, listGptModel, getLiveType} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "gpt样本" , key: "gpt_system", align: "center",editable: true,
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.gpt_system),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.gpt_system)
                ])
              ])
            } },
        { title: "gpt提问" , key: "gpt_content", align: "center",editable: true,
        render: (h, params) => {
              return h('div', [
              // 显示的位置上方
                h('Tooltip', {
                  props: { placement: 'top' ,transfer: true}
                }, [
                  h('span', {
                    style: {
                      display: 'inline-block',
                      width: '70px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }, params.row.gpt_content),
                  // 显示的内容
                  h('span', {
                    slot: 'content',
                    style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                  },params.row.gpt_content)
                ])
              ])
            } },
        { title: "gpt模型" , key: "gpt_model", editable: true , align: "center"},
        { title: "平台" , key: "live", editable: true , align: "center"},
        { title: "所属分类" , key: "classify_name", editable: true , align: "center"},
        { title: "所属标签" , key: "tag_name", editable: true , align: "center"},
        {title: "类型",key: "action_type", align: "center"},
        { title: "创建时间", key: "create_time", editable: true, align: "center"},
        {
          title: "Handle",
          key: "handle",width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addGpt.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addGpt.setClassifyData(classifyIds);
      });

      listGptModel().then((res) => {
        var gptModelIds = res.data.data;
        this.$refs.addGpt.setGptModel(gptModelIds);
      });

    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
      this.resetFlag = !this.resetFlag

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.editGpt.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.editGpt.setClassifyData(classifyIds);
        this.$refs.editGpt.setEditData(this.editData);
      });

      listGptModel().then((res) => {
        var gptModelIds = res.data.data;
        this.$refs.editGpt.setGptModel(gptModelIds);
      });

    },
    addSumit(formValidate) {
      const data = {
        gpt_content: formValidate.gpt_content,
        gpt_system: formValidate.gpt_system,
        classify_id: formValidate.classify_id,
        tag_id: formValidate.tag_id,
        gpt_model_id: formValidate.gpt_model_id,
        type: formValidate.type_id,
        live_id: formValidate.live_id
      };
      addGpt(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },    
    editSumit(formValidate) {
      const data = {
        gpt_content: formValidate.gpt_content,
        gpt_system: formValidate.gpt_system,
        classify_id: formValidate.classify_id,
        tag_id: formValidate.tag_id,
        gpt_model_id: formValidate.gpt_model_id,
        type: formValidate.type_id,
        live_id: formValidate.live_id
      };
      editGpt(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize
      };
      getGptList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteGpt(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        // this.tableData.splice(params.index, 1);
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
